import { TailSpin } from 'react-loader-spinner';

const PageLoading = ({color, classes}) => {
    return (
        <>
            <TailSpin
                height="50"
                width="50"
                color={color}
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperClass={classes}
                visible={true}
            />
        </>
    )
}

export default PageLoading;